import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = {
  class: "label is-inline-flex is-align-items-center",
  for: "incentiveProgram"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "Incentive Program", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-info-circle" })
], -1)
const _hoisted_5 = { class: "control is-expanded" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_selectOption = _resolveComponent("selectOption")
  const _component_field_validate = _resolveComponent("field-validate")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("label", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_tooltip, {
        class: "incentive-program-tooltip-icon is-inline ml-2",
        content: _ctx.incentiveTooltipContent,
        position: 'bottom',
        filter: 'span'
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["content"])
    ]),
    _createVNode("div", _hoisted_5, [
      _withDirectives((_openBlock(), _createBlock("div", { key: _ctx.selectKey }, [
        _createVNode(_component_selectOption, {
          modelValue: _ctx.modelValue,
          "populate-fn": _ctx.populateIncentiveProgramsByDistributor(),
          name: "incentiveProgram",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
        }, null, 8, ["modelValue", "populate-fn"]),
        _createVNode(_component_field_validate, { for: "incentiveProgram" })
      ], 512)), [
        [_vShow, _ctx.isAnyIncentivePrograms]
      ]),
      _withDirectives(_createVNode("div", null, "No programs available for this distributor", 512), [
        [_vShow, !_ctx.isAnyIncentivePrograms]
      ])
    ])
  ]))
}